import cookie from '@/utils/cookie'
import { getUrlParam, getUrlParamNotDecode } from '@/utils/util'
import LoginConfig from '@/config/config'
import sensors from '@/utils/sensors.js'

let UserLogin = {
    appThat: null,
    Current_IMEI_IS_true:true,
    setAppThat: function(appThat){
        this.appThat = appThat;
        return this;
    }
}

let urlParams = getUrlParam();
let _CookieNum = 8 //失效时间是几小时
let _CookieTime= new Date(new Date().getTime() + _CookieNum * 60 * 60 * 1000);

cookie.setDefaults({expires: _CookieTime});

let JSONstringify = function(data){
    let urlDataString = "";
    try{
        urlDataString = JSON.stringify(data);    
    }catch(e){
        console.log(e);
    }
    
    return urlDataString;
}

UserLogin.CurrentProjectChannel = function(){
    let projectChannel = cookie.getCookie('projectConfig');

    if(!projectChannel){
        if(urlParams.defaultProjectConfig){
            projectChannel = urlParams.defaultProjectConfig;
            UserLogin.setCoreConfig();
        }else{
            projectChannel = urlParams.projectConfig;
        }
    }

    return projectChannel;
}

UserLogin.ConcatOldData = function(){
    if(sessionStorage.getItem('TwiceLoginStatus')) return;

    let localStorage_UrlData = JSON.parse(localStorage.getItem('urlData') || '{}');
    let sessionStorage_UrlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');

    let newData = {
        ...localStorage_UrlData,
        ...sessionStorage_UrlData
    }

    if(Object.keys(newData).length){
        let urlDataString = JSONstringify(newData);
        sessionStorage.setItem('urlData',urlDataString);
        UserLogin.SaveDatas(newData);
    }

    sessionStorage.setItem('TwiceLoginStatus','true');

    UserLogin.AfterLoginHandle();
}


UserLogin.checkImei = function(){
    let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
    let urlDataLocal = JSON.parse(localStorage.getItem('urlData') || '{}');
    if(getUrlParamNotDecode().redirect_url){
        UserLogin.Current_IMEI_IS_true=false;
        window.location.replace(decodeURIComponent(getUrlParamNotDecode().redirect_url));
        return
    }
    const regex = /^\d+$/;
    let isLoginByLoginPage = JSON.parse(sessionStorage.getItem('isLoginByLoginPage') || 'false');
    if(isLoginByLoginPage && sessionStorage.getItem('loginPageUrl')){
        sessionStorage.setItem('loginStatus','false');
        UserLogin.Current_IMEI_IS_true=false;
        location.replace(sessionStorage.getItem('loginPageUrl'));
    } else if(urlDataLocal.isLoginByLoginPage){
        sessionStorage.setItem('loginStatus','false');
        UserLogin.Current_IMEI_IS_true=false;
    } else {
        if(!urlData.imei){
            //登录失败，提示用户刷新吧
            sessionStorage.setItem('loginStatus','false');
            UserLogin.Current_IMEI_IS_true=false;
            location.href = "/LoadFail?translateErrorMsg=IMEI_Not_Exist";
        }else if(!regex.test(urlData.imei)){
            //登录失败，含有非数字
            sessionStorage.setItem('loginStatus','false');
            UserLogin.Current_IMEI_IS_true=false;
            location.href = "/LoadFail?translateErrorMsg=IMEI_Not_Exist";
        }else{
            //可以前往登录，默认是IMEI正确
            UserLogin.Current_IMEI_IS_true=true;
        }
    }

}

//当前会话外
//数据存在 -再次复用  true
//数据消失 -重新请求  false
UserLogin.checkLogin = function(){
    let accessToken = cookie.getCookie('access_token');
    let localStorage_UrlData = JSON.parse(localStorage.getItem('urlData') || '{}');
    let sessionStorage_UrlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
    
    if(accessToken){
        if(localStorage_UrlData && sessionStorage_UrlData){
            if(localStorage_UrlData.imei == sessionStorage_UrlData.imei ){
                return true;     
            }
        }
        return false; 
    }
    return false;        
}

UserLogin.gotoLogin = async function(){
	let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');

    if(urlData.sn){
        //如果有sn，走sn登录流程
        await UserLogin.getSNLoginData();
    } else {
        //如果没有sn，走IMEI登录流程
        UserLogin.checkImei();
        if(UserLogin.Current_IMEI_IS_true){
            await UserLogin.getLoginData();    
        }
    }
    // if(!UserLogin.checkLogin()){
    //     UserLogin.getLoginData();
    // }else{
    //     UserLogin.ConcatOldData();    
    // }
}


UserLogin.getLoginData = async function(){
    let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
    let projectChannel = UserLogin.CurrentProjectChannel();
    localStorage.removeItem('isRegAndLogin');
    await UserLogin.appThat.$http.post({
        url: '/webmps/common/loginByImei',
        data: {                        
            imei:urlData.imei,
            projectChannel:projectChannel,
            registerCountry:urlData.registerCountry || '',
        }
    }).then(res => {
        // 神策-登录用户
        sensors.login(res.data.loginCustomerId);
        sessionStorage.setItem('isLoginByLoginPage', false);
        localStorage.setItem('isRegAndLogin',false);

        return UserLogin.loginSuccess(res);

    }).catch((err) => {

        //登录失败，提示用户刷新吧
        sessionStorage.setItem('loginStatus','false');
        location.href = "/LoadFail?translateErrorMsg=commonError"
    })

}

UserLogin.getSNLoginData = async function(){
    let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
    let projectChannel = UserLogin.CurrentProjectChannel();

    await UserLogin.appThat.$http.post({
        url: '/webmps/common/loginByImei',
        data: {                 
            "imei": "000000000000000",//固定参数写死
            "userCode":urlData.sn,//sn
            "isBindDevice":false,//固定参数写死
            "registerType":"02",//固定参数写死
            "projectChannel":projectChannel,
            // "streamNo": "web_Juan_IPC_Test1750659676597889286",
            // "partnerCode": "Juan_IPC_Test",
            // "langType": "zh-CN",
            // "channelType": "WEB"
        }
    }).then(res => {
        // 神策-登录用户
        sensors.login(res.data.loginCustomerId);
        sessionStorage.setItem('isLoginByLoginPage', false);

        return UserLogin.loginSuccess(res);

    }).catch((err) => {

        //登录失败，提示用户刷新吧
        sessionStorage.setItem('loginStatus','false');
        location.href = "/LoadFail?translateErrorMsg=commonError"
    })

}

UserLogin.loginSuccess = async function(SuccessData){
	//已经过滤成功数据
	let res = SuccessData.data;

    UserLogin.SaveDatas(res);

    UserLogin.FirstLoginHandle(res);
    

    //登录后处理
    await UserLogin.AfterLoginHandle();
}


UserLogin.FirstLoginHandle = function(res){
    //添加登录信息
    let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
    urlData = {
        ...urlData,
        ...res
    }
    
    if(Object.keys(urlData).length){
        let urlDataString = JSONstringify(urlData);
        sessionStorage.setItem('urlData',urlDataString);
        localStorage.setItem('urlData',urlDataString);
    }
    
    //登录状态更新
    cookie.setCookie('access_token', res.access_token);
    sessionStorage.setItem('loginStatus','true');
    sessionStorage.setItem('access_token', res.access_token);

    try{
        UserLogin.appThat.$projectConfig.loginStatus=true;
    }catch(e){
        //不需要处理
    }
}


UserLogin.AfterLoginHandle = async function(){

    let mvnoCode =cookie.getCookie('mvnoCode');

    if(location.pathname  == "/"){
        let newUrlParams =  location.search.replace(/projectConfig(.*?)\&/g,"projectConfig="+mvnoCode+"&"+"defaultProjectConfig="+urlParams.projectConfig+"&");
        if(urlParams.isRegister){
            localStorage.setItem('isRegisterUrl',urlParams.isRegister);
        }
        newUrlParams = newUrlParams.replace(/isRegister(.*?)\&/g,'')
        location.href = "/Home"+ newUrlParams;
    }
    if(location.pathname  == "/dp"){ 
        if(urlParams.goodsCode){
            location.href = "/dp/detail" + `?categoryCode=DIGITAL_PRODUCTS&relationCode=${urlParams.goodsCode}&souce=扫码跳转`
        }
    }
}


UserLogin.SaveDatas = function(res){
    UserLogin.setCookies(res);
    UserLogin.setStorage(res);
     //setCoreConfig
    UserLogin.setCoreConfig();
}

UserLogin.setCookies = function(data) {
    data.loginCustomerId && cookie.setCookie('loginCustomerId', data.loginCustomerId);
    data.mvnoCode && cookie.setCookie('mvnoCode', data.mvnoCode);
    data.orgId && cookie.setCookie('orgId', data.orgId);
    data.orgCode && cookie.setCookie('orgCode', data.orgCode);
}

UserLogin.setStorage = function(res){
    localStorage.setItem('access_token',res.access_token);
    localStorage.setItem('loginCustomerId',res.loginCustomerId);
    localStorage.setItem('mvnoCode', res.mvnoCode);
    localStorage.setItem("userInfo", JSON.stringify(res));
}

UserLogin.setCoreConfig = function(){
    if(location.pathname == "/"){
        cookie.setCookie('projectConfig',urlParams.projectConfig ,{expires: 365});        
    }

    if( !cookie.getCookie('projectConfig') && urlParams.defaultProjectConfig){
        cookie.setCookie('projectConfig',urlParams.defaultProjectConfig ,{expires: 365});        
        if(localStorage.langType){
            cookie.setCookie('langType', localStorage.langType,{expires: 365})    
        }
        
    }
}



export default UserLogin